import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useEffect, useState } from 'react';
import SearchTab from '../components/searchTab/SearchTab';
import TotalFilter from './filter/TotalFilter';
import EasyFilter from './filter/EasyFilter';
import Menu from '../components/menu/Menu';
import ScrollToTopButton from '../components/ScrollToTopButton';

const Search = () => {
  const [currentTab, setCurrentTab] = useState('간편검색');
  const [openMenu, setOpenMenu] = useState(false);

  const param = new URLSearchParams(window.location.search);
  const type = param.get('type');

  useEffect(() => {
    if (type === 'e') {
      setCurrentTab('간편검색');
    } else if (type === 'c') {
      setCurrentTab('종합검색');
    } else {
      setCurrentTab('간편검색');
    }
  }, [type]);

  const renderFilterComponent = () => {
    if (currentTab === '간편검색') {
      return <EasyFilter page="search" />;
    }
    if (currentTab === '종합검색') {
      return <TotalFilter />;
    }
  };

  return (
    <Container>
      <ScrollToTopButton />
      <PageTop text={currentTab} setOpenMenu={setOpenMenu} />
      <div>
        <SearchTab
          page="search"
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
        {renderFilterComponent()}
      </div>
      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};

export default Search;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;
